export const SPONSORED_BANNERS_CAROUSEL_EVENT = 'SponsoredBannersCarouselEvent';
